import { Avatar } from '@mui/material';
import React from 'react';
import { getNotificationTime } from '@utils';

const NotificationDetail = ({ selectedNotification }) => (
  <div className="mensageria-detail-content">
    <div className="mensageria-detail-header">
      <div className="mensageria-detail-header-left">
        <span
          className="mensageria-dot"
          style={{
            visibility:
              selectedNotification.Lida === null ? 'visible' : 'hidden',
          }}
        />
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: '#E77708',
            fontSize: '1rem',
          }}
        />
        <div>
          <p className="mensageria-detail-title">
            {selectedNotification.Titulo}
          </p>
          <span className="mensageria-detail-time">
            {getNotificationTime(selectedNotification)}
          </span>
        </div>
      </div>
    </div>

    {selectedNotification?.SubTitulo && (
      <div className="mensageria-detail-subTitle">
        {selectedNotification.SubTitulo}
      </div>
    )}
    {selectedNotification?.Mensagem && (
      <div className="mensageria-detail-body">
        {selectedNotification.Mensagem}
      </div>
    )}
    {selectedNotification?.MensagemAuxiliar && (
      <div className="mensageria-detail-body">
        {selectedNotification.MensagemAuxiliar}
      </div>
    )}
    {(selectedNotification.LinkExterno || selectedNotification.AnexoURL) && (
      <div className="mensageria-detail-actions">
        {selectedNotification.LinkExterno && (
          <a
            href={selectedNotification.LinkExterno}
            target="_blank"
            rel="noopener noreferrer"
            className="mensageria-action-link"
          >
            {selectedNotification.LinkExternoDescricao}
          </a>
        )}
        {selectedNotification.AnexoURL && (
          <a
            href={selectedNotification.AnexoURL}
            target="_blank"
            rel="noopener noreferrer"
            className="mensageria-action-link"
          >
            Baixar arquivo
          </a>
        )}
      </div>
    )}
  </div>
);

export default NotificationDetail;
